export default "__VITE_ASSET__ClyfqFlH__"